import { toast } from 'react-toastify'

import { api } from 'api'
import { Info, Success } from 'constants/actionMessages'
import { User, UserGetAllParams } from 'interfaces/api/users.interfaces'
import {
  CreateUserParams,
  RemoveUserParams,
  ResetUserPasswordParams,
  UpdateUserParams,
} from 'interfaces/store/users.interfaces'
import { createAction, createAsyncThunk } from 'modules/store'
import { ValidationErrorsApi } from 'packages/api'

export const getAllUsers = createAsyncThunk(
  'users/getAllUsers',
  async (params: UserGetAllParams | undefined, { rejectWithValue }) =>
    api.users.getAll(params).catch((error) => rejectWithValue(error.message)),
)

export const getUser = createAsyncThunk('users/getUser', async (id: number, { rejectWithValue }) =>
  api.users.getSingle(id).catch((error) => rejectWithValue(error.message)),
)

export const setSingleUser = createAction<User | null>('users/setSingleUser')
export const setUserValidationErrors = createAction<ValidationErrorsApi | null>('users/setUserValidationErrors')

export const createUser = createAsyncThunk(
  'users/createUser',
  async (params: CreateUserParams, { rejectWithValue, dispatch }) =>
    api.users
      .create(params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setUserValidationErrors(null))
        toast.success(Success.UserCreated)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setUserValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const updateUser = createAsyncThunk(
  'users/updateUser',
  async (params: UpdateUserParams, { rejectWithValue, dispatch }) =>
    api.users
      .update(params.id, params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setUserValidationErrors(null))
        toast.success(Success.Save)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setUserValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const removeUser = createAsyncThunk('users/removeUser', async (params: RemoveUserParams, { rejectWithValue }) =>
  api.users
    .remove(params.id)
    .then(() => {
      if (params.onSuccess) {
        params.onSuccess()
      }
      toast.info(Info.UserRemoved)
      return
    })
    .catch((error) => rejectWithValue(error.message)),
)

export const resetUserPassword = createAsyncThunk(
  'users/resetUserPassword',
  async (params: ResetUserPasswordParams, { rejectWithValue }) =>
    api.users
      .resetPassword(params.id)
      .then(() => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        return
      })
      .catch((error) => rejectWithValue(error.message)),
)
